import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import CsvUploadSteps from './CsvUploadSteps';
import { useTranslation } from 'react-i18next';
import { ReplaceProductListItems } from 'services/productList';

export interface ICsvData {
  key: number;
  rowNumber: number;
  companyName: string;
  countryCode3: string;
  productDescription?: string;
  transactionId?: string;
  hsCode6?: string;
}

export interface IInvalidData {
  key: number;
  rowNumber: number;
  column: string;
  error: string;
}

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

function BootstrapDialogTitle(props: DialogTitleProps) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

interface IProps {
  productListId: string;
  visible: boolean;
  onClose: () => void;
  onFinish: () => void;
}
export default function CsvUploadDialog(props: IProps) {
  const { visible, onClose, onFinish, productListId } = props;
  const [open, setOpen] = useState(false);
  const { t } = useTranslation('default');

  useEffect(() => {
    setOpen(visible);
  }, [visible]);

  const handleClose = () => {
    onClose();
  };

  const handleReplaceCompanyList = async (array: ICsvData[]) => {
    const list = array.map((item) => ({
      companyName: item.companyName,
      countryCode: item.countryCode3,
      productDescription: item.productDescription,
      transactionId: item.transactionId,
      hsCode6: item.hsCode6,
    }));
    await ReplaceProductListItems(productListId, list);
  };

  return (
    <div>
      <BootstrapDialog
        fullWidth={true}
        maxWidth={'md'}
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
          {t('upload-csv')}
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <CsvUploadSteps onUpload={handleReplaceCompanyList} onFinish={onFinish} />
        </DialogContent>
      </BootstrapDialog>
    </div>
  );
}
